import { QueryClient, useQuery } from "@tanstack/react-query";

const VOCABULARY_STATISTICS_QUERY_KEY = "vocabulary-statistics";

export function useVocabularyStatistics() {
  const query = useQuery({
    queryFn: ({ signal }) => fetchStatistics(signal),
    queryKey: [VOCABULARY_STATISTICS_QUERY_KEY],
  });

  return query;
}

type Statistics = {
  total_created: number;
  last_week_created: number;
  last_four_weeks_created: number;
  streak_gt5: number;
  streak_5: number;
  streak_4: number;
  streak_3: number;
  streak_2: number;
  streak_1: number;
  streak_0: number;
};

async function fetchStatistics(signal: AbortSignal): Promise<Statistics> {
  const res = await fetch("/api/reeprise/vocabulary/stats/", {
    signal,
  });
  if (!res.ok) {
    throw new Error("could not fetch vocabulary statistics");
  }
  return (await res.json()) as Statistics;
}

export function invalidateQuery(client: QueryClient): void {
  client.invalidateQueries({ queryKey: [VOCABULARY_STATISTICS_QUERY_KEY] });
}
